import { render, staticRenderFns } from "./BookingRequests.vue?vue&type=template&id=3b456300&"
import script from "./BookingRequests.vue?vue&type=script&lang=js&"
export * from "./BookingRequests.vue?vue&type=script&lang=js&"
import style0 from "./BookingRequests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports